import { get, getServiceResponse, handleClientError, post } from '../lib'

export const getEmailEnabled = async (): Promise<boolean> => {
  try {
    return get<boolean>({
      path: '/api/v1/registration/hasEmailEnabled',
      headers: {
        Accept: 'application/json, text/plain',
        'Content-Type': 'text/html;charset=utf-8'
      },
      respCb: (response) => {
        return response == 'true' ? true : false
      },
      text: true
    })
  } catch (e: any) {
    throw handleClientError(e)
  }
}

export const getResetDialog = async (): Promise<boolean> => {
  try {
    return get<boolean>({
      path: '/ui/partial/accounts/forgotPasswordDialog',
      headers: {
        Accept: 'application/json, text/plain',
        'Content-Type': 'text/html;charset=utf-8'
      },
      respCb: (response) => {
        return response == 'true' ? true : false
      },
      text: true
    })
  } catch (e: any) {
    throw handleClientError(e)
  }
}

export const postPasswordReset = async (username: string): Promise<string> => {
  try {
    return await post<string, string>({
      path: `/api/v1/registration/notifyPasswordReset?username=${username}`,
      body: '',
      headers: {
        Accept: 'application/json, text/plain',
        'Content-Type': 'text/html;charset=utf-8'
      },
      text: true
    })
  } catch (e: any) {
    throw handleClientError(e)
  }
}

export const getRegistrationEnabled = async (): Promise<boolean> => {
  try {
    return get<boolean>({
      path: '/api/v1/registration/isRegistrationEnabled',
      headers: {
        Accept: 'application/json, text/plain',
        'Content-Type': 'text/html;charset=utf-8'
      },
      respCb: (response) => {
        return response == 'true' ? true : false
      },
      text: true
    })
  } catch (e: any) {
    throw handleClientError(e)
  }
}
